import { render, staticRenderFns } from "./BulletinGalleryComponent.vue?vue&type=template&id=1995194a&scoped=true&"
import script from "./BulletinGalleryComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinGalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinGalleryComponent.vue?vue&type=style&index=0&id=1995194a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1995194a",
  null
  
)

export default component.exports